'use strict';

angular.module('amexReconciliationApp')
  .component('bcaInfo', {
    templateUrl: 'scripts/views/components/bca-info.html',
    controller: function (TransactionSearchModel, SiteConfigModel) {
      var self = this;

      self.siteName = SiteConfigModel.siteName;

      self.bcaIdentifiers = function() {
        var identifiers = [];

        var description = _.get(TransactionSearchModel.bca(), 'description', '');
        if(description !== null && description !== '') {
          identifiers.push(description);
        }

        var name = _.get(TransactionSearchModel.bca(), 'bcaName', '');
        if(name !== null && name !== '') {
          identifiers.push(name);
        }
        identifiers.push(_.get(TransactionSearchModel.bca(), 'bca', ''));

        return identifiers;
      };

    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/bcaInfo.js
// module id = 438
// module chunks = 0